var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 167 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M89.4609 5.8335L92.0377 9.21218L94.6254 5.8335H95.7366V12.9708H94.5111V7.85518L92.0486 11.0906L89.5649 7.84482V12.9708H88.3497V5.8335H89.4609ZM98.119 12.9708V5.8335H99.3451V10.9611L103.49 5.8335H104.55V12.9708H103.335V7.83445L99.1789 12.9708H98.119ZM109.283 10.4984H108.152V12.9708H106.935V5.8335H109.283C110.8 5.8335 111.84 6.84866 111.84 8.16593C111.84 9.48326 110.8 10.4984 109.283 10.4984ZM109.267 6.94017H108.145V9.39177H109.267C110.14 9.39177 110.638 8.85997 110.638 8.16593C110.638 7.47189 110.147 6.94017 109.267 6.94017ZM88.3408 23.0154V15.8781H89.5663V21.004L93.7113 15.8781H94.7711V23.0154H93.5648V17.8774L89.4007 23.0154H88.3408ZM97.1577 15.8781H98.3831V18.8338H102.029V15.8781H103.246V23.0154H102.029V19.9491H98.3831V23.0154H97.1666L97.1577 15.8781ZM105.626 15.8781H108.172C109.491 15.8781 110.374 16.7724 110.374 17.8481C110.386 18.115 110.33 18.3806 110.21 18.6215C110.091 18.8624 109.912 19.0711 109.689 19.2292C110.046 19.3553 110.354 19.5876 110.566 19.8927C110.779 20.1978 110.887 20.5602 110.874 20.928C110.874 22.1038 109.896 23.0188 108.494 23.0188H105.626V15.8781ZM108.11 18.8839C108.774 18.8839 109.181 18.4713 109.181 17.9188C109.181 17.4009 108.774 16.9538 108.11 16.9538H106.841V18.8839H108.11ZM108.467 21.9398C109.255 21.9398 109.693 21.5168 109.693 20.9143C109.693 20.3117 109.255 19.8887 108.467 19.8887H106.841V21.9398H108.467ZM112.804 15.8781H117.242V17.0038H114.021V18.8338H116.617V19.9595H114.021V21.8897H117.242V23.0154H112.804V15.8781ZM118.609 19.4467C118.609 17.3559 120.251 15.7572 122.454 15.7572C124.238 15.7572 125.643 16.8725 126.007 18.271H124.697C124.387 17.4561 123.493 16.8897 122.454 16.8897C120.916 16.8897 119.835 18.0051 119.835 19.4432C119.835 20.8814 120.916 21.9967 122.454 21.9967C123.493 21.9967 124.387 21.4338 124.697 20.6155H126.007C125.65 22.0122 124.223 23.1292 122.454 23.1292C120.251 23.1362 118.609 21.5374 118.609 19.4467ZM129.308 17.0038H127.166V15.8781H132.673V17.0038H130.532V23.0154H129.317L129.308 17.0038ZM134.401 23.0154V15.8781H135.626V21.004L139.78 15.8781H140.84V23.0154H139.623V17.8774L135.46 23.0154H134.401ZM149.91 21.8897V24.5002H148.788V23.0154H143.219V15.8781H144.444V21.8897H147.749V15.8781H148.975V21.8897H149.91ZM151.752 23.0154V15.8781H152.985V21.004L157.13 15.8781H158.19V23.0154H156.974V17.8774L152.806 23.0154H151.752ZM160.568 23.0153V15.8781H161.794V21.004L165.94 15.8781H167V23.0153H165.784V17.8774L161.628 23.0153H160.568ZM162.158 13.7563H162.957C162.957 14.3606 163.314 14.7317 163.884 14.7317C164.452 14.7317 164.807 14.3606 164.807 13.7563H165.607C165.615 13.9799 165.575 14.2027 165.492 14.4114C165.409 14.6202 165.283 14.8106 165.122 14.9713C164.961 15.1321 164.768 15.2599 164.556 15.3472C164.343 15.4345 164.114 15.4795 163.882 15.4795C163.651 15.4795 163.422 15.4345 163.209 15.3472C162.996 15.2599 162.804 15.1321 162.643 14.9713C162.482 14.8106 162.356 14.6202 162.273 14.4114C162.189 14.2027 162.15 13.9799 162.158 13.7563Z",
    fill: "#006DF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7355 12.8472C44.427 13.0894 45.0655 13.4532 45.6186 13.9199C46.1438 14.4082 46.5722 14.9842 46.8828 15.6199C47.1869 16.2969 47.3388 17.0281 47.3284 17.7654C47.3389 18.4945 47.1869 19.2174 46.8828 19.8854C46.5748 20.5226 46.1378 21.0945 45.5975 21.5677C45.0571 22.0408 44.4241 22.4057 43.7355 22.6412C42.9656 22.9135 42.1512 23.0512 41.3308 23.0475H32.6738V6.12689H45.8149V9.41647H36.2915V12.4663H41.3291C42.1483 12.455 42.9632 12.584 43.7355 12.8472ZM43.1379 16.181C42.6024 15.7982 41.9462 15.6043 41.2795 15.6318H36.2915V19.8531H41.2795C41.9459 19.8803 42.6018 19.6871 43.1379 19.3057C43.61 18.9486 43.8328 18.4557 43.8328 17.7569C43.8328 17.0582 43.61 16.5414 43.1379 16.181ZM54.0368 23.0475H50.5747V6.12689H54.0368V13.3011L60.1918 6.12689H64.4956L57.4759 14.2531L65.9631 23.0475H61.4437L54.0368 15.3735V23.0475ZM71.2766 22.6412C69.0941 21.7745 67.357 20.1128 66.444 18.0188C65.9743 16.9313 65.7379 15.7638 65.7491 14.5864C65.7367 13.4331 65.9625 12.2889 66.4135 11.2203C66.8648 10.1516 67.5319 9.17963 68.3767 8.36082C69.208 7.56548 70.1931 6.93424 71.2766 6.50265C72.4482 6.04339 73.7046 5.81615 74.9705 5.83453C75.9461 5.83158 76.9164 5.97615 77.8453 6.26294C78.7443 6.56381 79.5952 6.98381 80.3736 7.51076C81.1147 8.04898 81.7662 8.69217 82.3066 9.41822C82.8558 10.1685 83.2585 11.0083 83.4965 11.8969H79.6061C79.4372 11.4734 79.185 11.085 78.8636 10.7528C78.5368 10.4145 78.1605 10.1241 77.7463 9.89086C77.3306 9.66813 76.8899 9.49244 76.4323 9.3672C75.9556 9.24404 75.4641 9.18002 74.9705 9.17683C74.1901 9.16877 73.4151 9.30617 72.6889 9.58142C72.017 9.84849 71.4102 10.2461 70.9051 10.7494C70.4155 11.2464 70.0284 11.8285 69.7646 12.4647C69.4928 13.1409 69.3599 13.8615 69.3741 14.5864C69.3619 15.3116 69.4961 16.0321 69.7701 16.708C70.0338 17.3442 70.4203 17.9263 70.9105 18.4234C71.4095 18.927 72.019 19.3177 72.6943 19.5675C73.4151 19.8621 74.1921 20.0081 74.9752 19.9959C75.4695 19.9927 75.961 19.9288 76.4377 19.8055C76.9001 19.6824 77.3422 19.4982 77.7517 19.2581C78.1693 19.0421 78.547 18.7599 78.867 18.4234C79.1884 18.0912 79.4406 17.7028 79.6101 17.2793H83.4999C83.2619 18.1603 82.8585 18.9923 82.31 19.7341C81.7764 20.4655 81.1235 21.1095 80.377 21.6416C79.6101 22.1838 78.7558 22.6023 77.8486 22.8809C76.9238 23.1869 75.9515 23.3399 74.9738 23.3331C73.7053 23.3442 72.4476 23.1089 71.2766 22.6412Z",
    fill: "#006DF0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_34974_45458",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 27,
    height: 26
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3116 26.8332C20.6634 26.8332 26.6232 21.0875 26.6232 13.9998C26.6232 6.91218 20.6634 1.1665 13.3116 1.1665C5.9598 1.1665 0 6.91218 0 13.9998C0 21.0875 5.9598 26.8332 13.3116 26.8332Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_34974_45458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2154 20.4537C28.8987 14.162 26.4857 6.12401 19.8258 2.50029C13.166 -1.12343 4.78119 1.03934 1.09791 7.33101C-2.58537 13.6226 -0.172366 21.6606 6.4875 25.2844C13.1474 28.9081 21.5321 26.7453 25.2154 20.4537Z",
    fill: "url(#paint0_linear_34974_45458)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_34974_45458",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 27,
    height: 26
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3116 26.8332C20.6634 26.8332 26.6232 21.0875 26.6232 13.9998C26.6232 6.91218 20.6634 1.1665 13.3116 1.1665C5.9598 1.1665 0 6.91218 0 13.9998C0 21.0875 5.9598 26.8332 13.3116 26.8332Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_34974_45458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5281 19.1627C29.0427 14.511 27.2509 7.48091 21.526 3.46075C15.8011 -0.559437 8.31093 -0.0474194 4.79634 4.60436C1.28173 9.25617 3.07354 16.2862 8.79844 20.3064C14.5234 24.3265 22.0135 23.8145 25.5281 19.1627Z",
    fill: "url(#paint1_radial_34974_45458)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_34974_45458",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 27,
    height: 26
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3116 26.8332C20.6634 26.8332 26.6232 21.0875 26.6232 13.9998C26.6232 6.91218 20.6634 1.1665 13.3116 1.1665C5.9598 1.1665 0 6.91218 0 13.9998C0 21.0875 5.9598 26.8332 13.3116 26.8332Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_34974_45458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6209 13.1712C27.3645 9.91191 24.5359 5.1608 19.3033 2.55931C14.0707 -0.0421748 8.41546 0.491118 6.67201 3.75045C4.92854 7.00976 7.75707 11.7609 12.9897 14.3624C18.2222 16.9639 23.8775 16.4306 25.6209 13.1712Z",
    fill: "url(#paint2_radial_34974_45458)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34974_45458",
    x1: 20.6035,
    y1: 43.3841,
    x2: 13.3132,
    y2: -3.73414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006DEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0570EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#1277F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#2884F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4896F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70ADF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A1C9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#DBEAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_34974_45458",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.7562 18.0442) rotate(105.833) scale(19.7814 34.2151)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#006DEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#0671EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#187BF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#358BF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#5EA3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#92C1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#D1E4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F0F6FD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_34974_45458",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.2265 5.75194) rotate(47.2491) scale(28.5645 24.1575)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#006DEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#0F75F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#529CF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8BBCF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B6D5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D6E7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#E9F2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F0F6FD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a722da046f409e8321e8b8aa1df74152.svg";
export { ForwardRef as ReactComponent };